import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Carrega um documento completo (com contentJson/contentHtml) para edição.
export function useDocument() {
  const [isLoading, setLoading] = useState(false);

  const fetchDocument = useCallback((patientId, documentId) => {
    setLoading(true);
    return quarkusApi
      .get(`/patients/${patientId}/documents/${documentId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setLoading(false));
  }, []);

  return { fetchDocument, isLoading };
}
